/* eslint-disable  */
import React from 'react';
import { useState } from 'react';
import { Button, Grid, TextField } from '@material-ui/core';


const DepartmentForm = props => {

    const {
        initialValues,
        setModalOpen,
        onSubmit
    } = props;

    const [name, setName] = useState(initialValues?.name)
    const[enabled, setEnabled] = useState(false)



    const handleSubmit = async (event)  => {
        event.preventDefault();
        setEnabled(true)
        onSubmit && onSubmit({
            ...initialValues,
            name
        })
      }

    const handleChangeDeptName = (e) => {
        setName(e.target.value)
        setEnabled(true)
        }

    
    return (
   
            <form onSubmit={handleSubmit} >

                <Grid container spacing={3} justifyContent='flex-end'>

                    <TextField
                        name='Department_name'
                        value={name || ''}
                        label='Department Name'
                        fullWidth
                        onChange={handleChangeDeptName}
                    >
                    </TextField>

                    <Grid item >
                        <Button color='secondary' 
                            onClick={() => setModalOpen(false)}>
                            Cancel
                        </Button>
                    </Grid>

                    <Grid item>
                        <Button type='submit' 
                            variant='contained'
                            color='primary'
                            disabled={!enabled}
                            onClick={ handleSubmit}>
                            Submit
                        </Button>
                    </Grid>

                </Grid>

            </form>
        )}


function validate(values) {
    const errors = {};
    if (!values.name) {
        errors.name = 'Required';
    }

    return errors;
}


export default DepartmentForm;
